<template>
  <div>
    <RequestDetail
      :request-number="requestNumber"
      :status-color="statusColor"
      :status-name="statusName"
    />
    <BitacoraHistory
      :blog-items="blogItems"
      @download="downloadFile($event)"
      @load-bitacora="fetchBitacoraHistory()"
      @remove-blog="removeBlog"
      
    />
  </div>
</template>
<script>
import documentsService from "@/services/documents";
import BitacoraHistory from "./BitacoraHistory";
import RequestDetail from "./RequestDetail";
import { getBitacoraItems, deleteBitacoraItems } from "@/modules/referral/api";
import alert from "@/mixin/alert.mixin";

export default {
  name: 'BitacoraHistoryTab',
  components: {
    BitacoraHistory,
    RequestDetail,
  },
  mixins: [alert],
  props: {
    requestId: {
      type: Number,
      default: 0,
    },
    requestNumber: {
      type: String,
      default: '',
    },
    statusName: {
      type: String,
      default: '',
    },
    statusColor: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      blogItems: [],
    };
  },
  mounted() {
    this.fetchBitacoraHistory();
  },
  methods: {
    async downloadFile(fileId) {
      await documentsService.downloadDocumentByAttachmentIdOrDocumentId(fileId);
    },
    async fetchBitacoraHistory() {
      const { data } = await getBitacoraItems(this.requestId);
      this.blogItems = data;
    },
    limitedBlogItems() {
      return this.showMore
        ? this.blogItems
        : this.blogItems.slice(0, this.initialMaxPreview);
    },
    async removeBlog(blogId){
      let hasError = false;
      await deleteBitacoraItems(blogId).catch(error => {
        const errorMsg = error.data && error.data.message
          ? error.data.message
          : error.response.data.message;
        this.ShowToast("Error", errorMsg, "error");
        hasError = true;
      });

      if(hasError) return;

      this.ShowToast(
              "Proceso exitoso",
              "Se Eliminó Comentario de Bitácora satisfactoriamente",
              "success"
            );

      // refresh history
      this.fetchBitacoraHistory();
    },
  },
};
</script>